module.exports = __webpack_public_path__ + "static/img/login-background.4af15a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/login-background.png
// module id = R3j5
// module chunks = 0